import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
export const SortDownIcon = (_a) => {
    var { size } = _a, rest = __rest(_a, ["size"]);
    return (_jsx("svg", Object.assign({ width: size, height: size }, rest, { fill: 'none', viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg', children: _jsx("path", { d: 'M15.75 17.25L12 21M12 21L8.25 17.25M12 21L12 3', stroke: 'currentColor', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }) })));
};
//# sourceMappingURL=sort_down.icon.js.map